<template>
  <div class="page flex-col">
    <div class="gg" @click="tiaozhuan">
      <img src="../assets/shouyi2.png" alt="" />
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      constants: {},
    };
  },
  methods: {
    tiaozhuan() {
      console.log("dianji11111111111111");
      window.location = "http://localhost:8084/platform/ceshi1";
    },
  },
};
</script>
<style>
.page {
  width: 1980px;
  height: 1080px;

  float: left;
}
</style>